var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "priceboost priceboost--single-reversed promo-container",
      style: {
        "background-image":
          "url(" + _vm.scContent.FieldValues.Parameters["img_background"] + ")"
      }
    },
    [
      _c("div", { staticClass: "event-content" }, [
        _c("div", { staticClass: "event-odds" }, [
          _c("div", { staticClass: "event-odds__was" }, [
            _c("span", { staticClass: "event-odds__value" }, [
              _vm._v(
                _vm._s(
                  _vm._f("twoDecimalsNumber")(
                    _vm.event.Event.Market.Option[_vm.priceboostSelection][
                      "@odds"
                    ]
                  )
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "a",
            { staticClass: "event-odds__now", attrs: { href: _vm.betSlipUrl } },
            [
              _c("span", { staticClass: "event-odds__value" }, [
                _vm._v(
                  _vm._s(_vm.scContent.FieldValues.Parameters["copy_now-odds"])
                )
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "event" }, [
          _c("div", {
            staticClass: "event__claim",
            domProps: {
              innerHTML: _vm._s(
                _vm.scContent.FieldValues.Parameters["copy_claim"]
              )
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "button__wrapper" }, [
            !_vm.loggedin
              ? _c(
                  "a",
                  {
                    staticClass: "button button--cta button--md",
                    attrs: { href: _vm.registrationUrl }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.scContent.FieldValues.Parameters["copy_cta"])
                    )
                  ]
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "event-text",
          domProps: { innerHTML: _vm._s(_vm.scContent.FieldValues.Text) }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b1a935a", { render: render, staticRenderFns: staticRenderFns })
  }
}